<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <domainClass-table
            v-if="domainClasses && domainClasses.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:domainClasses="domainClasses"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-domain-classs="getAllDomainClasses"
             >

            </domainClass-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import DomainClassTable from "@/components/DomainClassTable";
import DomainClassService from "../services/DomainClassService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    DomainClassTable,
  },
  data() {
    return {
      domainClasses: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllDomainClasses(sortBy='domainClassId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await DomainClassService.getAllDomainClasses(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.domainClasses.length) {
					this.domainClasses = response.data.domainClasses;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching domainClasses:", error);
        }
        
      } catch (error) {
        console.error("Error fetching domainClass details:", error);
      }
    },
  },
  mounted() {
    this.getAllDomainClasses();
  },
  created() {
    this.$root.$on('searchQueryForDomainClassesChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllDomainClasses();
    })
  }
};
</script>
<style></style>
